import { render } from "./exchange_eric.vue?vue&type=template&id=2470300e&scoped=true"
import script from "./exchange_eric.vue?vue&type=script&lang=js"
export * from "./exchange_eric.vue?vue&type=script&lang=js"

import "./exchange_eric.vue?vue&type=style&index=0&id=2470300e&lang=css&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\project\\forex\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2470300e"]])

export default __exports__